
import { NBMessageSuccess, NBMessageInfo } from './nBMessage'
import { stringify } from 'querystring'

/**
 *
 * @param _that this
 * 分装 element messageBox 方便实用
 * @param title 提示内容
 */
interface Res {
  status:string,
  msg:()=>void
}
export const NBMessageBox = (_that: any, title: string = '是否执行该操作') => {
  // eslint-disable-next-line promise/param-names
  return new Promise<Res>((res, rej) => {
    _that
      .$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        res({
          status: 'success',
          msg: () => NBMessageSuccess(_that)
        })
      })
      .catch(() => {
        // eslint-disable-next-line prefer-promise-reject-errors
        rej({
          status: 'error',
          msg: () => NBMessageInfo(_that)
        })
      })
  })
}
